var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { FormSettingsContext } from "../../utils";
import { SpacingEditor } from "./spacingEditor";
export var Spacing = function () {
    var _a = useContext(FormSettingsContext), settings = _a.settings, editedSettings = _a.editedSettings;
    var nullValue = {
        top: "",
        right: "",
        bottom: "",
        left: "",
    };
    var _b = useState(nullValue), editedValueP = _b[0], setEditedValueP = _b[1];
    var _c = useState(nullValue), editedValueM = _c[0], setEditedValueM = _c[1];
    useEffect(function () {
        // Update current settings of component
        setSettings();
    }, [editedValueP, editedValueM]);
    var setSettings = function () {
        var currentC = {};
        currentC = settings.currentComponent &&
            settings.currentComponent.settings && __assign(__assign({}, settings.currentComponent), { settings: __assign(__assign({}, settings.currentComponent.settings), { styles: __assign(__assign({}, settings.currentComponent.settings.styles), { spacing: { padding: editedValueP, margin: editedValueM } }) }) });
        editedSettings(__assign(__assign({}, settings), { currentComponent: currentC, isDirty: true }));
    };
    function getType(type, value) {
        type === "padding" && setEditedValueP(value);
        type === "margin" && setEditedValueM(value);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "my-2" }, { children: [_jsx("label", { children: "Padding" }), _jsx(SpacingEditor, { getType: getType, type: "padding" }), _jsx("label", { children: "Margin" }), _jsx(SpacingEditor, { getType: getType, type: "margin" })] })) }));
};
